<mat-paginator
  #paginator
  [id]="id"
  color="primary"
  (page)="pageOptsUpdated($event)"
  [disabled]="searchResultPage?.totalPages === 0"
  [length]="searchResultPage?.totalElements"
  [pageIndex]="searchResultPage?.page"
  [pageSize]="preferences.itemsPerPage"
  [pageSizeOptions]="preferences.itemsPerPageChoices"
  [showFirstLastButtons]="preferences.showFirstLastButtons"
  [hidePageSize]="preferences.hidePageSize"
>
</mat-paginator>
